import React from 'react';
import AdminNotificationBell from '../../../../Components/NotificationBell/AdminNotificationBell';
import './navbar.scss';

function AdminNavbar({ hideLogo }) {
  return (
    <div className={`MonetizingHeader adminTopbar ${!hideLogo ? 'campaingSideBar' : ''}`}>
      <div className="innerMonetizingHeader">
        <div className="notificationIcon">
          <AdminNotificationBell />
        </div>
      </div>
    </div>
  );
}

export default AdminNavbar;
